class KPIConfig extends BaseItemConfig {

    indicatorMetric: KnockoutObservable<number>;
    targetMetric: KnockoutObservable<number>;
    comparisonFilter: ComparisonFilter;
    trendAxisField: KnockoutObservable<number>;
    trendAxisFieldAutoGrouping: KnockoutObservable<AutoGroupingEnum> = ko.observable(AutoGroupingEnum.None);
    showTrendAxis: KnockoutObservable<boolean> = ko.observable(true);
    trendAxisHeight: KnockoutObservable<number> = ko.observable(80);
    decimalPlaces: KnockoutObservable<number>;
    format: KnockoutObservable<FieldFormatEnum> = ko.observable(FieldFormatEnum.Numeric);
    accountingStyle: KnockoutObservable<boolean>;
    showLargeNumber: KnockoutObservable<boolean> = ko.observable(true);
    indicatorFontSize: KnockoutObservable<number> = ko.observable(45);
    indicatorFontColor: KnockoutObservable<string>;
    indicatorFontBold: KnockoutObservable<boolean>;
    indicatorFontItalic: KnockoutObservable<boolean>;
    private _titleText: KnockoutObservable<string>;
    //get titleText() { return this._titleText; }
    //set titleText(value: string) {
    //    //if (this.indicatorMetric != null && this.indicatorMetric.MetricName == value)
    //    //    _titleText = null;
    //    //else
    //    this._titleText(value);
    //}
    titleText = ko.pureComputed({
        read: function (this: KPIConfig) {
            return this._titleText();
        },
        write: function (this: KPIConfig, value) {
            //if (this.indicatorMetric != null && this.indicatorMetric.MetricName == value)
            //    _titleText = null;
            //else
            this._titleText(value);
        },
        owner: this
    });
    titleTextConfig: BaseTextConfig = new BaseTextConfig({ fontSize: 14 });
    targetText: KnockoutObservable<string>;
    targetTextConfig: BaseTextConfig = new BaseTextConfig({ fontSize: 14 });
    showDistanceFromTarget: KnockoutObservable<boolean>;
    distanceType: KnockoutObservable<DistanceTypeEnum> = ko.observable(DistanceTypeEnum.Percent);
    backgroundColor: KnockoutObservable<string>;
    formattingRule: KnockoutObservable<number>;
    useLastPeriod: KnockoutObservable<boolean>;
    showIcon: KnockoutObservable<boolean> = ko.observable(true);
    iconSize: KnockoutObservable<number> = ko.observable(0);
    tabDetailOrderByField: KnockoutObservable<KpiFieldEnum> = ko.observable(KpiFieldEnum.PercentageVariation);
    tabDetailOrderByDirection: KnockoutObservable<Order> = ko.observable(Order.DESC);
    filterZeros: KnockoutObservable<boolean>;


    get allowDetailTab() { return true; }

    constructor(data: any) {
        super(data);

        this.indicatorMetric = ko.observable(data.indicatorMetric);
        this.targetMetric = ko.observable(data.targetMetric);
        this.comparisonFilter = new ComparisonFilter(data.comparisonFilter);
        this.trendAxisField = ko.observable(data.trendAxisField);
        this.trendAxisFieldAutoGrouping = ko.observable(data.trendAxisFieldAutoGrouping);
        this.showTrendAxis = ko.observable(data.showTrendAxis);
        this.trendAxisHeight = ko.observable(data.trendAxisHeight);
        this.decimalPlaces = ko.observable(data.decimalPlaces);
        this.format = ko.observable(data.format);
        this.accountingStyle = ko.observable(data.accountingStyle);
        this.showLargeNumber = ko.observable(data.showLargeNumber);
        this.indicatorFontSize = ko.observable(data.indicatorFontSize);
        this.indicatorFontColor = ko.observable(data.indicatorFontColor);
        this.indicatorFontBold = ko.observable(data.indicatorFontBold);
        this.indicatorFontItalic = ko.observable(data.indicatorFontItalic);
        this._titleText = ko.observable(data.titleText);
        this.titleTextConfig = new BaseTextConfig(data.titleTextConfig);
        this.targetText = ko.observable(data.targetText);
        this.targetTextConfig = new BaseTextConfig(data.targetTextConfig);
        this.showDistanceFromTarget = ko.observable(data.showDistanceFromTarget);
        this.distanceType = ko.observable(data.distanceType);
        this.backgroundColor = ko.observable(data.backgroundColor);
        this.useLastPeriod = ko.observable(data.useLastPeriod);
        this.showIcon = ko.observable(data.showIcon);
        this.iconSize = ko.observable(data.iconSize);
        this.tabDetailOrderByField = ko.observable(data.tabDetailOrderByField);
        this.tabDetailOrderByDirection = ko.observable(data.tabDetailOrderByDirection);
        this.filterZeros = ko.observable(data.filterZeros);

        this.formattingRule = ko.observable(data.formattingRule);
    }
}

class BaseTextConfig {
    show: KnockoutObservable<boolean> = ko.observable(true);
    fontSize: KnockoutObservable<number>;
    fontColor: KnockoutObservable<string> = ko.observable("");
    backgroundColor: KnockoutObservable<string> = ko.observable("");
    alignment: KnockoutObservable<TextAlignmentEnum> = ko.observable(TextAlignmentEnum.Left);
    fontBold: KnockoutObservable<boolean> = ko.observable(false);
    fontItalic: KnockoutObservable<boolean> = ko.observable(false);

    alignmentStyleValue = ko.computed(function (this: BaseTextConfig) {
        switch (this.alignment()) {
            case TextAlignmentEnum.Center:
                return "center";
            case TextAlignmentEnum.Left:
                return "left";
            case TextAlignmentEnum.Right:
                return "right";
        }
    }, this);

    constructor(data)
    {
        this.fontSize = ko.observable(data.fontSize);

        if (data.show !== undefined) {
            this.show(data.show);
            this.fontColor(data.fontColor);
            this.backgroundColor(data.backgroundColor);
            this.alignment(data.alignment);
            this.fontBold(data.fontBold);
            this.fontItalic(data.fontItalic);
        }
    }
}

enum TextAlignmentEnum {
    Left = 0,
    Center = 1,
    Right = 2
}

enum DistanceTypeEnum {
    Value = 0,
    Percent = 1,
    Percent100 = 2,
    ValuePercent = 3,
    ValuePercent100 = 4
}

enum KpiFieldEnum {
    Indicator = 0,
    Target = 1,
    Variation = 2,
    PercentageVariation = 3,
    None = 4
}

enum Order {
    NONE = 0,
    ASC = 1,
    DESC = 2
}